<template>
    <label class="def-email">
        <span class="def-email__label">
            {{ label }}
        </span>
        <input
            :type="type"
            :name="name"
            :required="required"
            :value="saveValue"
            :autocomplete="autocomplete"
            :id="id"
            :form="form"
            :class="{ 'def-email__invalid': !isValid }"
            :placeholder="placeholder"
            @input="handlerInput"
            @change="$emit('change', $event)"
            @click="$emit('click', $event)"
            @keypress="$emit('keypress', $event)"
            @keydown="$emit('keydown', $event)"
            @keyup="$emit('keyup', $event)"
            @invalid.prevent="handlerInvalid"
            @blur="handlerBlur"
            @focus="handlerFocus"
            class="def-email__input"
            pattern="^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$"
            ref="email"
        >
    </label>
</template>

<script>
export default {
    name: 'DefEmail',
    props: {
        name: String,
        placeholder: String,
        required: Boolean,
        autocomplete: Boolean,
        value: {
            type: String,
            default: '',
        },
        id: String,
        label: String,
        form: String,
        type: {
            type: String,
            default: 'text',
        },
        isError: Boolean
    },
    data() {
        return {
            isValid: true,
            isFocus: false,
            saveValue: this.value,
        }
    },
    methods: {
        handlerInput(e) {
            // console.log(e.target.value);
            this.saveValue = e.target.value;
            this.$emit('input', e);
        },
        handlerInvalid(e) {
            if (this.required) {
                this.isValid = false;
            }

            this.$emit('invalid', e);
        },
        handlerBlur(e) {
            const target = e.target;
            this.saveValue = target.value;
            if (target.checkValidity() && this.required) {
                this.isValid = true;
            }
            this.isFocus = false;
            this.$emit('blur', e);
        },
        handlerFocus(e) {
            this.isFocus = true;
            this.$emit('focus', e);
        }
    },
    watch: {
        value(newValue) {
            this.saveValue = newValue;
        }
    },
    mounted() {
        // const email = new Inputmask({
        //     mask: '*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@{1}*{1,20}d{1}*{2,6}[.*{1,5}]',
        //     greedy: false,
        //     definitions: {
        //         '*': {
        //             validator: "[0-9A-Za-z_-]",
        //             cardinality: 1,
        //             casing: "lower"
        //         },
        //         '@': {
        //             validator: '@',
        //             cardinality: 1,
        //             casing: 'lower'
        //         },
        //         'd': {
        //             validator: '.',
        //             cardinality: 1,
        //             casing: 'lower'
        //         }
        //     }
        // });
        // email.mask(this.$refs.email);
    }
}
</script>

<style lang="scss" scoped>
.def-email{
    display: inline-block;
    position: relative;
    &__input{
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        border: 1px solid #DFDFDF;
        padding: 0 22px;
        transition: .2s linear border-color;
        width: 100%;
        height: 50px;
        &::placeholder{
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
        }
    }
    &__invalid{
        border-color: var(--danger);
    }
    &__label{
        display: block;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
    }
}
</style>